import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "price-empty d-flex flex-column align-center text-center py-16",
      attrs: { "data-qa": "lpu_services_service_not_found" },
    },
    [
      _c(VImg, {
        staticClass: "mb-2",
        attrs: {
          src: _vm.emptySrc,
          width: "150",
          height: "150",
          contain: "",
          alt: "",
        },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "text--text text-body-1" }, [
        _vm._v(
          "\n    " +
            _vm._s(_setup.tStatic("Такой услуги нет в клинике")) +
            "\n  "
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }